const paletas = {
    TPCB_BrBG: [
        [0x65b3d8, 0xf5f5f5, 0xacb45a],
        [0x1a61a6, 0x7dc2df, 0xc1cd80, 0x718501],
        [0x1a61a6, 0x7dc2df, 0xf5f5f5, 0xc1cd80, 0x718501],
        [0x0a518c, 0x65b3d8, 0xc3e8f6, 0xe5eac7, 0xacb45a, 0x5e6601],
        [0x0a518c, 0x65b3d8, 0xc3e8f6, 0xf5f5f5, 0xe5eac7, 0xacb45a, 0x5e6601],
        [
            0x0a518c, 0x2d81bf, 0x7dc2df, 0xc3e8f6, 0xe5eac7, 0xc1cd80,
            0x8f9735, 0x5e6601,
        ],
        [
            0x0a518c, 0x2d81bf, 0x7dc2df, 0xc3e8f6, 0xf5f5f5, 0xe5eac7,
            0xc1cd80, 0x8f9735, 0x5e6601,
        ],
        [
            0x053054, 0x0a518c, 0x2d81bf, 0x7dc2df, 0xc3e8f6, 0xe5eac7,
            0xc1cd80, 0x8f9735, 0x5e6601, 0x303c00,
        ],
        [
            0x053054, 0x0a518c, 0x2d81bf, 0x7dc2df, 0xc3e8f6, 0xf5f5f5,
            0xe5eac7, 0xc1cd80, 0x8f9735, 0x5e6601, 0x303c00,
        ],
    ],
    TPCB_PiYG: [
        [0xc9a3e9, 0xf7f7f7, 0x6ad7a1],
        [0x8b1cd0, 0xdab6f1, 0x86e1b8, 0x26ac4d],
        [0x8b1cd0, 0xdab6f1, 0xf7f7f7, 0x86e1b8, 0x26ac4d],
        [0x7d1bc5, 0xc9a3e9, 0xefe0fd, 0xd0f5e6, 0x6ad7a1, 0x21924d],
        [0x7d1bc5, 0xc9a3e9, 0xefe0fd, 0xf7f7f7, 0xd0f5e6, 0x6ad7a1, 0x21924d],
        [
            0x7d1bc5, 0xae77de, 0xdab6f1, 0xefe0fd, 0xd0f5e6, 0x86e1b8,
            0x41bc7f, 0x21924d,
        ],
        [
            0x7d1bc5, 0xae77de, 0xdab6f1, 0xefe0fd, 0xf7f7f7, 0xd0f5e6,
            0x86e1b8, 0x41bc7f, 0x21924d,
        ],
        [
            0x52018e, 0x7d1bc5, 0xae77de, 0xdab6f1, 0xefe0fd, 0xd0f5e6,
            0x86e1b8, 0x41bc7f, 0x21924d, 0x196427,
        ],
        [
            0x52018e, 0x7d1bc5, 0xae77de, 0xdab6f1, 0xefe0fd, 0xf7f7f7,
            0xd0f5e6, 0x86e1b8, 0x41bc7f, 0x21924d, 0x196427,
        ],
    ],
    TPCB_Spectral: [
        ['#598DFC', '#BFFFFF', '#94D599'],
        ['#1C19D7', '#61AEFD', '#A4DDAB', '#BA832B'],
        ['#1C19D7', '#61AEFD', '#BFFFFF', '#A4DDAB', '#BA832B'],
        ['#4F3ED5', '#598DFC', '#8BE0FE', '#98F5E6', '#94D599', '#BD8832'],
        [
            '#4F3ED5',
            '#598DFC',
            '#8BE0FE',
            '#BFFFFF',
            '#98F5E6',
            '#94D599',
            '#BD8832',
        ],
        [
            '#4F3ED5',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#98F5E6',
            '#A4DDAB',
            '#A5C266',
            '#BD8832',
        ],
        [
            '#4F3ED5',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#BFFFFF',
            '#98F5E6',
            '#A4DDAB',
            '#A5C266',
            '#BD8832',
        ],
        [
            '#42019E',
            '#4F3ED5',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#98F5E6',
            '#A4DDAB',
            '#A5C266',
            '#BD8832',
            '#A24F5E',
        ],
        [
            '#42019E',
            '#4F3ED5',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#BFFFFF',
            '#98F5E6',
            '#A4DDAB',
            '#A5C266',
            '#BD8832',
            '#A24F5E',
        ],
    ],
    PRGn: [
        ['#C38DAF', '#F7F7F7', '#7BBF7F'],
        ['#94327B', '#CFA5C2', '#A0DBA6', '#378800'],
        ['#94327B', '#CFA5C2', '#F7F7F7', '#A0DBA6', '#378800'],
        ['#832A76', '#C38DAF', '#E8D4E7', '#D3F0D9', '#7BBF7F', '#37781B'],
        [
            '#832A76',
            '#C38DAF',
            '#E8D4E7',
            '#F7F7F7',
            '#D3F0D9',
            '#7BBF7F',
            '#37781B',
        ],
        [
            '#832A76',
            '#AB7099',
            '#CFA5C2',
            '#E8D4E7',
            '#D3F0D9',
            '#A0DBA6',
            '#61AE5A',
            '#37781B',
        ],
        [
            '#832A76',
            '#AB7099',
            '#CFA5C2',
            '#E8D4E7',
            '#F7F7F7',
            '#D3F0D9',
            '#A0DBA6',
            '#61AE5A',
            '#37781B',
        ],
        [
            '#4B0040',
            '#832A76',
            '#AB7099',
            '#CFA5C2',
            '#E8D4E7',
            '#D3F0D9',
            '#A0DBA6',
            '#61AE5A',
            '#37781B',
            '#1B4400',
        ],
        [
            '#4B0040',
            '#832A76',
            '#AB7099',
            '#CFA5C2',
            '#E8D4E7',
            '#F7F7F7',
            '#D3F0D9',
            '#A0DBA6',
            '#61AE5A',
            '#37781B',
            '#1B4400',
        ],
    ],
    PuOr: [
        ['#40A3F1', '#F7F7F7', '#C38E99'],
        ['#0161E6', '#63B8FD', '#D2ABB2', '#993C5E'],
        ['#0161E6', '#63B8FD', '#F7F7F7', '#D2ABB2', '#993C5E'],
        ['#0658B3', '#40A3F1', '#B6E0FE', '#EBDAD8', '#C38E99', '#882754'],
        [
            '#0658B3',
            '#40A3F1',
            '#B6E0FE',
            '#F7F7F7',
            '#EBDAD8',
            '#C38E99',
            '#882754',
        ],
        [
            '#0658B3',
            '#1482E0',
            '#63B8FD',
            '#B6E0FE',
            '#EBDAD8',
            '#D2ABB2',
            '#AC7380',
            '#882754',
        ],
        [
            '#0658B3',
            '#1482E0',
            '#63B8FD',
            '#B6E0FE',
            '#F7F7F7',
            '#EBDAD8',
            '#D2ABB2',
            '#AC7380',
            '#882754',
        ],
        [
            '#083B7F',
            '#0658B3',
            '#1482E0',
            '#63B8FD',
            '#B6E0FE',
            '#EBDAD8',
            '#D2ABB2',
            '#AC7380',
            '#882754',
            '#4B002D',
        ],
        [
            '#083B7F',
            '#0658B3',
            '#1482E0',
            '#63B8FD',
            '#B6E0FE',
            '#F7F7F7',
            '#EBDAD8',
            '#D2ABB2',
            '#AC7380',
            '#882754',
            '#4B002D',
        ],
    ],
    RdBu: [
        ['#628AEF', '#F7F7F7', '#CFA967'],
        ['#2000CA', '#82A5F4', '#DEC592', '#B07105'],
        ['#2000CA', '#82A5F4', '#F7F7F7', '#DEC592', '#B07105'],
        ['#2B18B2', '#628AEF', '#C7DBFD', '#F0E5D1', '#CFA967', '#AC6621'],
        [
            '#2B18B2',
            '#628AEF',
            '#C7DBFD',
            '#F7F7F7',
            '#F0E5D1',
            '#CFA967',
            '#AC6621',
        ],
        [
            '#2B18B2',
            '#4D60D6',
            '#82A5F4',
            '#C7DBFD',
            '#F0E5D1',
            '#DEC592',
            '#C39343',
            '#AC6621',
        ],
        [
            '#2B18B2',
            '#4D60D6',
            '#82A5F4',
            '#C7DBFD',
            '#F7F7F7',
            '#F0E5D1',
            '#DEC592',
            '#C39343',
            '#AC6621',
        ],
        [
            '#1F0067',
            '#2B18B2',
            '#4D60D6',
            '#82A5F4',
            '#C7DBFD',
            '#F0E5D1',
            '#DEC592',
            '#C39343',
            '#AC6621',
            '#613005',
        ],
        [
            '#1F0067',
            '#2B18B2',
            '#4D60D6',
            '#82A5F4',
            '#C7DBFD',
            '#F7F7F7',
            '#F0E5D1',
            '#DEC592',
            '#C39343',
            '#AC6621',
            '#613005',
        ],
    ],

    RdGy: [
        ['#628AEF', '#FFFFFF', '#999999'],
        ['#2000CA', '#82A5F4', '#BABABA', '#404040'],
        ['#2000CA', '#82A5F4', '#FFFFFF', '#BABABA', '#404040'],
        ['#2B18B2', '#628AEF', '#C7DBFD', '#E0E0E0', '#999999', '#4D4D4D'],
        [
            '#2B18B2',
            '#628AEF',
            '#C7DBFD',
            '#FFFFFF',
            '#E0E0E0',
            '#999999',
            '#4D4D4D',
        ],
        [
            '#2B18B2',
            '#4D60D6',
            '#82A5F4',
            '#C7DBFD',
            '#E0E0E0',
            '#BABABA',
            '#878787',
            '#4D4D4D',
        ],
        [
            '#2B18B2',
            '#4D60D6',
            '#82A5F4',
            '#C7DBFD',
            '#FFFFFF',
            '#E0E0E0',
            '#BABABA',
            '#878787',
            '#4D4D4D',
        ],
        [
            '#1F0067',
            '#2B18B2',
            '#4D60D6',
            '#82A5F4',
            '#C7DBFD',
            '#E0E0E0',
            '#BABABA',
            '#878787',
            '#4D4D4D',
            '#1A1A1A',
        ],
        [
            '#1F0067',
            '#2B18B2',
            '#4D60D6',
            '#82A5F4',
            '#C7DBFD',
            '#FFFFFF',
            '#E0E0E0',
            '#BABABA',
            '#878787',
            '#4D4D4D',
            '#1A1A1A',
        ],
    ],
    RdYlBu: [
        ['#598DFC', '#BFFFFF', '#DBBF91'],
        ['#1C19D7', '#61AEFD', '#E9D9AB', '#B67B2C'],
        ['#1C19D7', '#61AEFD', '#BFFFFF', '#E9D9AB', '#B67B2C'],
        ['#2730D7', '#598DFC', '#90E0FE', '#F8F3E0', '#DBBF91', '#B47545'],
        [
            '#2730D7',
            '#598DFC',
            '#90E0FE',
            '#BFFFFF',
            '#F8F3E0',
            '#DBBF91',
            '#B47545',
        ],
        [
            '#2730D7',
            '#436DF4',
            '#61AEFD',
            '#90E0FE',
            '#F8F3E0',
            '#E9D9AB',
            '#D1AD74',
            '#B47545',
        ],
        [
            '#2730D7',
            '#436DF4',
            '#61AEFD',
            '#90E0FE',
            '#BFFFFF',
            '#F8F3E0',
            '#E9D9AB',
            '#D1AD74',
            '#B47545',
        ],
        [
            '#2600A5',
            '#2730D7',
            '#436DF4',
            '#61AEFD',
            '#90E0FE',
            '#F8F3E0',
            '#E9D9AB',
            '#D1AD74',
            '#B47545',
            '#953631',
        ],
        [
            '#2600A5',
            '#2730D7',
            '#436DF4',
            '#61AEFD',
            '#90E0FE',
            '#BFFFFF',
            '#F8F3E0',
            '#E9D9AB',
            '#D1AD74',
            '#B47545',
            '#953631',
        ],
    ],
    RdYlGn: [
        ['#598DFC', '#BFFFFF', '#60CF91'],
        ['#1C19D7', '#61AEFD', '#6AD9A6', '#41961A'],
        ['#1C19D7', '#61AEFD', '#BFFFFF', '#6AD9A6', '#41961A'],
        ['#2730D7', '#598DFC', '#8BE0FE', '#8BEFD9', '#60CF91', '#50981A'],
        [
            '#2730D7',
            '#598DFC',
            '#8BE0FE',
            '#BFFFFF',
            '#8BEFD9',
            '#60CF91',
            '#50981A',
        ],
        [
            '#2730D7',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#8BEFD9',
            '#6AD9A6',
            '#63BD66',
            '#50981A',
        ],
        [
            '#2730D7',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#BFFFFF',
            '#8BEFD9',
            '#6AD9A6',
            '#63BD66',
            '#50981A',
        ],
        [
            '#2600A5',
            '#2730D7',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#8BEFD9',
            '#6AD9A6',
            '#63BD66',
            '#50981A',
            '#376800',
        ],
        [
            '#2600A5',
            '#2730D7',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#BFFFFF',
            '#8BEFD9',
            '#6AD9A6',
            '#63BD66',
            '#50981A',
            '#376800',
        ],
    ],
    Spectral: [
        ['#598DFC', '#BFFFFF', '#94D599'],
        ['#1C19D7', '#61AEFD', '#A4DDAB', '#BA832B'],
        ['#1C19D7', '#61AEFD', '#BFFFFF', '#A4DDAB', '#BA832B'],
        ['#4F3ED5', '#598DFC', '#8BE0FE', '#98F5E6', '#94D599', '#BD8832'],
        [
            '#4F3ED5',
            '#598DFC',
            '#8BE0FE',
            '#BFFFFF',
            '#98F5E6',
            '#94D599',
            '#BD8832',
        ],
        [
            '#4F3ED5',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#98F5E6',
            '#A4DDAB',
            '#A5C266',
            '#BD8832',
        ],
        [
            '#4F3ED5',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#BFFFFF',
            '#98F5E6',
            '#A4DDAB',
            '#A5C266',
            '#BD8832',
        ],
        [
            '#42019E',
            '#4F3ED5',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#98F5E6',
            '#A4DDAB',
            '#A5C266',
            '#BD8832',
            '#A24F5E',
        ],
        [
            '#42019E',
            '#4F3ED5',
            '#436DF4',
            '#61AEFD',
            '#8BE0FE',
            '#BFFFFF',
            '#98F5E6',
            '#A4DDAB',
            '#A5C266',
            '#BD8832',
            '#A24F5E',
        ],
    ],
    coloresTempAltas: [
        '#4CAF50', // Verde brillante
        '#81C784', // Verde claro
        '#FFEB3B', // Amarillo brillante
        '#FFC107', // Amarillo cálido
        '#FFD54F', // Amarillo suave
        '#FFEE58', // Amarillo claro
        '#FF9800', // Naranja vibrante
        '#FFB74D', // Naranja claro
        '#F57C00', // Naranja profundo
        '#EF5350', // Rojo cálido
        '#D32F2F', // Rojo oscuro
    ],
    coloresTempsBajas: [
        '#1E88E5', // Azul más intenso        
        '#42A5F5', // Azul moderado
        '#64B5F6', // Azul suave
        '#81C784', // Verde claro
        '#66BB6A', // Verde templado
        '#4CAF50', // Verde brillante
        '#AEEA00', // Verde limón suave
        '#FFEB3B', // Amarillo suave
        '#FFEE58', // Amarillo pálido
        '#FFCA28', // Naranja suave
        '#FFB74D', // Naranja claro
    ],
}

export { paletas as default }
